import React, { useState, useEffect, useMemo, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useHomeContext } from "../../context/Home_context";
import {
  FiX,
  FiChevronDown,
  FiChevronRight,
  FiPhone,
  FiMail,
  FiInfo,
  FiGrid,
  FiLayers,
  FiUsers,
  FiImage,
  FiCompass,
  FiBookOpen,
  FiUserCheck,
  FiVideo,
  FiCamera,
  FiUser,
  FiMapPin,
  FiFileText,
} from "react-icons/fi";
import {
  FaFacebookF,
  FaXTwitter,
  FaInstagram,
  FaLinkedinIn,
  FaYoutube,
} from "react-icons/fa6";
import "./Navbar.css";

const menuItemsData = [
  {
    id: "about",
    title: "About Bharat Buildcon",
    icon: <FiInfo />,
    path: "/aboutus",
    children: [
      {
        id: "about-exhibition",
        title: "About Exhibition",
        path: "/aboutus",
      },
      {
        id: "vision-mission",
        title: "Vision, Mission, Core Values",
        path: "/aboutus#vision-mission",
      },
      {
        id: "advisory-committee",
        title: "Advisory Committee",
        path: "/#advisory-committee",
      },
      {
        id: "stakeholders-committee",
        title: "Stakeholder’s Committee",
        path: "",
        badge: "TBC",
      },
    ],
  },
  {
    id: "directors-message",
    title: "Director’s Message",
    icon: <FiUser />,
    path: "/directorsmessage",
  },
  {
    id: "why-exhibit",
    title: "Why Exhibit?",
    icon: <FiLayers />,
    path: "/exhibition",
  },
  {
    id: "exhibitor-inquiry",
    title: "Exhibitor Inquiry",
    icon: <FiUsers />,
    path: "/exhibitors",
  },
  // {
  //   id: "editions",
  //   title: "Editions",
  //   icon: <FiLayers />,
  //   children: [],
  // },
  // {
  //   id: "conference",
  //   title: "Conference",
  //   icon: <FiUsers />,
  //   path: "/conferences",
  // },
  // {
  //   id: "gallery",
  //   title: "Gallery",
  //   icon: <FiImage />,
  //   path: "/gallery",
  // },
  {
    id: "why-visit",
    title: "Why Visit?",
    icon: <FiCompass />,
    path: "/whyvisit",
  },
  // {
  //   id: "newsletter",
  //   title: "Newsletter",
  //   icon: <FiBookOpen />,
  //   path: "/newsletter",
  //   children: [
  //     { id: "blogs", title: "Blogs", path: "/blogs" },
  //     {
  //       id: "social-wall",
  //       title: "Social Wall of Fame",
  //       path: "/socialwalloffame",
  //     },
  //     {
  //       id: "news-articles",
  //       title: "News Articles",
  //       path: "/newsarticles",
  //     },
  //     {
  //       id: "digital-media",
  //       title: "Digital Media Coverage",
  //       path: "/digitalmediacoverage",
  //     },
  //   ],
  // },
  {
    id: "registration",
    title: "Visitors Registration",
    icon: <FiUserCheck />,
    path: "/registration",
    badge: "Open",
    children: [
      {
        id: "domestic-visitors",
        title: "Domestic Visitors",
        path: "/domesticvisitors",
      },
      {
        id: "international-visitors",
        title: "International Visitors",
        path: "/internationalvisitors",
      },
    ],
  },
  {
    id: "brochure",
    title: "Brochure",
    icon: <FiFileText />,
    path: "/exhibition#brochures",
  },
  {
    id: "about-venue",
    title: "About Venue",
    icon: <FiMapPin />,
    path: "/exhibition#about-venue",
  },
  // {
  //   id: "floorplan",
  //   title: "Floorplan",
  //   icon: <FiGrid />,
  //   path: "/exhibition#plan-layout",
  // },
  {
    id: "contact",
    title: "Contact Us",
    icon: <FiMail />,
    path: "/contactus",
  },
];

const Navbar = () => {
  const {
    current_contact_data,
    GetEditionCategory,
    edition_category_data,
    GetEditionExpo,
    edition_expo_data,
    edition_expo_loading,
  } = useHomeContext();
  const [isOpen, setIsOpen] = useState(false);
  const [openAccordion, setOpenAccordion] = useState({});
  const [isScrolled, setIsScrolled] = useState(false);
  const [brochureLoadingId, setBrochureLoadingId] = useState(null);
  const hasRequestedBrochureRef = useRef(false);
  const navigate = useNavigate();
  const location = useLocation();
  const heroPages = ["/", "/edition"];
  const isHeroPage =
    heroPages.includes(location.pathname) ||
    location.pathname.startsWith("/edition");
  const isHeroTransparent = isHeroPage && !isScrolled;

  const navbarLogo = current_contact_data?.contact_image_full_path || null;

  const menuItems = useMemo(() => {
    const hasEditionData =
      Array.isArray(edition_category_data) && edition_category_data.length > 0;

    return menuItemsData.map((item) => {
      if (item.id !== "editions") return item;

      if (!hasEditionData) {
        // API data nathi (loading/error/empty) - editions khali j rakho
        return { ...item, children: [] };
      }

      const dynamicEditions = edition_category_data.map((cat, idx) => {
        const catId = cat.id || idx + 1;
        const editionPath = `/edition/${catId}`;
        const badgeText = cat.badge || cat.name || `Edition ${idx + 1}`;

        const subItems = [
          {
            id: `e-${catId}-about`,
            title: `About ${cat.name || cat.title || "Edition"}`,
            path: editionPath,
          },
          {
            id: `e-${catId}-brochure`,
            title: "Brochure",
            isBrochure: true,
            catId: catId,
          },
          {
            id: `e-${catId}-sectors`,
            title: "Sectors",
            path: `${editionPath}#focus-sectors`,
          },
          {
            id: `e-${catId}-media`,
            title: "Media",
            children: [
              {
                id: `e-${catId}-media-videos`,
                title: "1 Videos Section",
                path: `${editionPath}#videos`,
                icon: <FiVideo />,
              },
              {
                id: `e-${catId}-media-photos`,
                title: "2 Photos Section",
                path: editionPath,
                icon: <FiCamera />,
              },
            ],
          },
          {
            id: `e-${catId}-conference`,
            title: "Conference",
            path: editionPath,
          },
        ];

        return {
          id: `edition-cat-${catId}`,
          title: cat.name || cat.title || `Edition ${idx + 1}`,
          badge: badgeText,
          path: editionPath,
          children: subItems,
        };
      });

      return { ...item, children: dynamicEditions };
    });
  }, [edition_category_data]);
  // Fetch edition category data once when Navbar mounts
  useEffect(() => {
    if (GetEditionCategory) {
      GetEditionCategory();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      setIsScrolled((prevScrolled) => {
        if (!prevScrolled && scrollY > 60) {
          return true;
        }
        if (prevScrolled && scrollY < 20) {
          return false;
        }
        return prevScrolled;
      });
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Lock body scroll when drawer open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [isOpen]);

  const toggleAccordion = (id) => {
    setOpenAccordion((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const handleLinkClick = (path) => {
    setIsOpen(false);
    if (path) {
      if (path.includes("#")) {
        const [targetRoute, elementId] = path.split("#");
        const currentPath = location.pathname;
        const normalizedTarget = targetRoute || "/";

        navigate(path);
        const delay = currentPath === normalizedTarget ? 80 : 350;
        setTimeout(() => {
          const el =
            document.getElementById(elementId) ||
            document.getElementById(elementId.replace(/_/g, "-")) ||
            document.getElementById(elementId.replace(/-/g, "_"));
          if (el) {
            el.scrollIntoView({ behavior: "smooth" });
          }
        }, delay);
      } else {
        navigate(path);
      }
    }
  };

  const openEditionBrochure = (catId, e) => {
    if (e) e.stopPropagation();
    if (!catId || !GetEditionExpo) return;

    setBrochureLoadingId(catId);
    hasRequestedBrochureRef.current = true;
    GetEditionExpo(catId);
  };

  useEffect(() => {
    if (hasRequestedBrochureRef.current && edition_expo_loading === false) {
      hasRequestedBrochureRef.current = false;
      setBrochureLoadingId(null);

      if (edition_expo_data?.brochure_full_path) {
        window.open(
          edition_expo_data.brochure_full_path,
          "_blank",
          "noopener,noreferrer",
        );
        setIsOpen(false);
      } else {
        console.warn("Brochure is not available.");
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [edition_expo_loading]);

  // Render tree recursively
  const renderMenuItems = (items, level = 1) => {
    return items.map((item) => {
      const hasChildren = item.children && item.children.length > 0;
      const isExpanded = !!openAccordion[item.id];

      if (hasChildren) {
        return (
          <div key={item.id} className={`sidebar-node level-${level}`}>
            <button
              type="button"
              className={`sidebar-node-btn ${isExpanded ? "open" : ""}`}
              onClick={() => toggleAccordion(item.id)}
            >
              <div className="node-left">
                {item.icon && <span className="node-icon">{item.icon}</span>}

                {item.path ? (
                  <span
                    className="node-title node-title-link"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleLinkClick(item.path);
                    }}
                    title={`Open ${item.title}`}
                  >
                    {item.title}
                  </span>
                ) : (
                  <span className="node-title">{item.title}</span>
                )}
              </div>
              <span className="node-chevron">
                {isExpanded ? <FiChevronDown /> : <FiChevronRight />}
              </span>
            </button>
            <div
              className={`sidebar-node-children ${isExpanded ? "show" : ""}`}
            >
              {renderMenuItems(item.children, level + 1)}
            </div>
          </div>
        );
      }

      return (
        <div key={item.id} className={`sidebar-leaf level-${level}`}>
          <button
            type="button"
            className="sidebar-leaf-btn"
            disabled={item.isBrochure && brochureLoadingId === item.catId}
            onClick={(e) => {
              if (item.isBrochure) {
                openEditionBrochure(item.catId, e);
              } else {
                handleLinkClick(item.path);
              }
            }}
          >
            <div className="leaf-left">
              {item.icon ? (
                <span className="leaf-icon">{item.icon}</span>
              ) : (
                <span className="leaf-dot" />
              )}
              <span className="leaf-title">
                {item.isBrochure && brochureLoadingId === item.catId
                  ? "Loading..."
                  : item.title}
              </span>
              {item.note && <span className="leaf-note">{item.note}</span>}
            </div>
            {item.badge && (
              <span className="leaf-badge notranslate" translate="no">
                {item.badge}
              </span>
            )}
          </button>
        </div>
      );
    });
  };

  return (
    <>
      {/* Main Navbar Bar */}
      <header
        className={`clean-navbar ${isHeroTransparent ? "hero-transparent" : "scrolled"
          }`}
      >
        {/* Top Indian Tricolor Accent Line */}
        <div className="nav-top-tricolor-line" />

        <div className="clean-nav-container">
          {/* Logo */}
          <Link to="/" className="clean-nav-logo-link notranslate">
            {navbarLogo && (
              <img
                src={navbarLogo}
                alt="Bharat Buildcon Logo"
                className="clean-nav-logo"
              />
            )}
          </Link>

          {/* Right Action Menu Button */}
          <div className="clean-nav-actions">
            <button
              type="button"
              className="clean-menu-btn"
              onClick={() => setIsOpen(true)}
              aria-label="Open Navigation Menu"
            >
              <span className="menu-burger-wrapper">
                <span className="line line-1" />
                <span className="line line-2" />
                <span className="line line-3" />
              </span>
              <span className="menu-btn-text">Menu</span>
            </button>
          </div>
        </div>
      </header>

      {/* Backdrop Dimmed Overlay */}
      <div
        className={`drawer-backdrop ${isOpen ? "active" : ""}`}
        onClick={() => setIsOpen(false)}
      />

      {/* Off-Canvas Sidebar Drawer */}
      <aside className={`clean-sidebar-drawer ${isOpen ? "open" : ""}`}>
        {/* Drawer Header */}
        <div className="drawer-header">
          <div className="drawer-logo-container">
            {navbarLogo && (
              <img
                src={navbarLogo}
                alt="Bharat Buildcon"
                className="drawer-logo"
              />
            )}
          </div>
          <button
            type="button"
            className="drawer-close-btn"
            onClick={() => setIsOpen(false)}
            aria-label="Close menu"
          >
            <FiX />
          </button>
        </div>

        {/* Navigation Body */}
        <div className="drawer-nav-body">
          <nav className="drawer-tree-nav">{renderMenuItems(menuItems, 1)}</nav>
        </div>

        {/* Drawer Footer */}
        <div className="drawer-footer">
          <div className="drawer-contact-details">
            {(current_contact_data?.domestic_mobile1 ||
              current_contact_data?.whatsapp_no ||
              current_contact_data?.number) && (
                <div className="contact-row">
                  <FiPhone className="c-icon" />
                  <a
                    href={`tel:${String(
                      current_contact_data?.domestic_mobile1 ||
                      current_contact_data?.whatsapp_no ||
                      "",
                    ).replace(/\s+/g, "")}`}
                    className="notranslate"
                    translate="no"
                  >
                    {current_contact_data?.domestic_mobile1 ||
                      current_contact_data?.whatsapp_no ||
                      ""}
                  </a>
                </div>
              )}
            {current_contact_data?.domestic_mobile2 && (
              <div className="contact-row">
                <FiPhone className="c-icon" />
                <a
                  href={`tel:${String(
                    current_contact_data.domestic_mobile2,
                  ).replace(/\s+/g, "")}`}
                  className="notranslate"
                  translate="no"
                >
                  {current_contact_data.domestic_mobile2}
                </a>
              </div>
            )}
            {(current_contact_data?.domestic_email ||
              current_contact_data?.email) && (
                <div className="contact-row">
                  <FiMail className="c-icon" />
                  <a
                    href={`mailto:${current_contact_data?.domestic_email ||
                      current_contact_data?.email
                      }`}
                  >
                    {current_contact_data?.domestic_email ||
                      current_contact_data?.email}
                  </a>
                </div>
              )}
          </div>

          {/* All Social Media Links */}
          {(current_contact_data?.fb_link ||
            current_contact_data?.twitter_link ||
            current_contact_data?.youtube_link ||
            current_contact_data?.linkdin_link ||
            current_contact_data?.insta_link) && (
              <div className="drawer-social-section">
                <span className="social-heading">Follow Us</span>
                <div className="social-icons-row">
                  {current_contact_data?.fb_link && (
                    <a
                      href={current_contact_data.fb_link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="s-icon fb"
                      aria-label="Facebook"
                    >
                      <FaFacebookF />
                    </a>
                  )}
                  {current_contact_data?.twitter_link && (
                    <a
                      href={current_contact_data.twitter_link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="s-icon tw"
                      aria-label="Twitter"
                    >
                      <FaXTwitter />
                    </a>
                  )}
                  {current_contact_data?.insta_link && (
                    <a
                      href={current_contact_data.insta_link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="s-icon ig"
                      aria-label="Instagram"
                    >
                      <FaInstagram />
                    </a>
                  )}
                  {current_contact_data?.linkdin_link && (
                    <a
                      href={current_contact_data.linkdin_link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="s-icon in"
                      aria-label="LinkedIn"
                    >
                      <FaLinkedinIn />
                    </a>
                  )}
                  {current_contact_data?.youtube_link && (
                    <a
                      href={current_contact_data.youtube_link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="s-icon yt"
                      aria-label="YouTube"
                    >
                      <FaYoutube />
                    </a>
                  )}
                </div>
              </div>
            )}
        </div>
      </aside>
    </>
  );
};

export default Navbar;
